import { Injectable } from "@angular/core";

// The default theme (E) is compiled into the main stylesheet (last import in
// styles.scss). Every other theme is built as its own stylesheet (theme-a.css,
// theme-b.css, ...) by the "styles" entries with inject:false in angular.json
// and loaded on demand with a <link>, because Angular 14+ no longer supports
// require("x.scss") from TypeScript.
//
// The <link> is appended at the end of <head> so it comes after the main
// stylesheet and wins the cascade, like the <style> this service used to inject.
const OPTIONAL_THEMES = ["A", "B", "C", "D", "F", "G", "H"];

@Injectable()
export class ThemesService {
  linkTag: HTMLLinkElement = null;
  defaultTheme: string = "E";

  setTheme(name) {
    if (name === this.defaultTheme) {
      // back to the built-in theme: drop any extra theme stylesheet
      this.removeLink();
      return;
    }
    if (OPTIONAL_THEMES.indexOf(name) === -1) {
      return;
    }
    this.ensureLink().setAttribute("href", `theme-${name.toLowerCase()}.css`);
  }

  getDefaultTheme() {
    return this.defaultTheme;
  }

  private ensureLink(): HTMLLinkElement {
    if (!this.linkTag) {
      this.linkTag = document.createElement("link");
      this.linkTag.rel = "stylesheet";
      this.linkTag.id = "appthemes";
    }
    // (re)append so it is always the last stylesheet in <head>
    const head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(this.linkTag);
    return this.linkTag;
  }

  private removeLink() {
    if (this.linkTag && this.linkTag.parentNode) {
      this.linkTag.parentNode.removeChild(this.linkTag);
    }
  }
}
